import { $api } from "../generated/client";

export const useGetFilters = (shopId: string) => {
  return $api.useQuery("get", "/shops/{shopId}/return-requests/filters", {
    params: { path: { shopId } },
  });
};
